import AuthCardLayout from "@/components/molecules/AuthCardLayout";
import { EMAIL_REGEX } from "@/constants/regexs";
import { INVALID_EMAIL_MESSAGE } from "@/constants/validatorMessages";
import { IForgotPassword } from "@/interfaces/ForgotPassword";
import { useForgotPasswordMutation } from "@/services/auth";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { FC } from "react";
import { Button, Form } from "react-bootstrap";
import { SubmitErrorHandler, SubmitHandler, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { ToastContentProps, toast } from "react-toastify";

const ForgotPasswordView: FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IForgotPassword>();
  const [sendForgotPasswordAsync] = useForgotPasswordMutation();
  const navigation = useNavigate();

  const onSubmit: SubmitHandler<IForgotPassword> = async (data) => {
    await toast.promise(sendForgotPasswordAsync(data).unwrap(), {
      pending: "Envoi du code à 6 chiffres en cours...",
      success: {
        render() {
          navigation(`/auth/resetForgotPassword/${data.email}`);
          return (
            <p style={{ marginBottom: 0, textAlign: "center" }}>
              Le code a été envoyé à votre adresse email
            </p>
          );
        },
      },
      error: {
        render({ data }: ToastContentProps<FetchBaseQueryError>) {
          if (data?.status === 422) {
            return "L'adresse mail que vous avez renseignez n'existe pas.";
          } else if (data?.status === 403) {
            return "Vous avez déjà demandé un code de vérification, veuillez vérifier votre boite mail.";
          }

          return "Une erreur est survenue";
        },
      },
    });
  };

  const onError: SubmitErrorHandler<IForgotPassword> = () => {};

  return (
    <AuthCardLayout
      leftSideContent={
        <p className="text-white">
          Vous n&apos;avez pas de compte ?
          <br />
          <Link
            className="text-white text-decoration-underline"
            to="/auth/register"
          >
            Faire une demande
          </Link>
        </p>
      }
    >
      <h3>Mot de passe oublié</h3>
      <Form className="mt-4" onSubmit={handleSubmit(onSubmit, onError)}>
        <Form.Group className="mb-3">
          <Form.Control
            placeholder="ex : remi@groupe-pi.fr"
            type="text"
            {...register("email", {
              required: "L email est obligatoire",
              pattern: {
                value: EMAIL_REGEX,
                message: INVALID_EMAIL_MESSAGE,
              },
            })}
            isInvalid={!!errors.email}
          />
          <Form.Control.Feedback type="invalid">
            {errors.email?.message}
          </Form.Control.Feedback>
          <Form.Text id="passwordHelpBlock" muted>
            Votre adresse email doit être celle que vous avez utilisé pour vous
            inscrire.
          </Form.Text>
        </Form.Group>

        <Button className="w-100 mb-3" type="submit">
          Envoyé le code à 6 chiffres
        </Button>

        <Link className="fs--1 text-600" to="/auth/login">
          Retour à la page de connexion
          <span className="d-inline-block ms-1"> &rarr;</span>
        </Link>
      </Form>
    </AuthCardLayout>
  );
};

export default ForgotPasswordView;
